// Analytics event hooks — no tracking script installed.
// Events are pushed to window.dataLayer (GTM/GA-ready) and dispatched as a
// 'konek-analytics' CustomEvent so Meta Pixel or others can subscribe later.
export const trackEvent = (name, data = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...data });
    if (typeof window.gtag === "function") window.gtag("event", name, data);
    if (typeof window.fbq === "function") window.fbq("trackCustom", name, data);
    window.dispatchEvent(new CustomEvent("konek-analytics", { detail: { name, ...data } }));
  } catch {
    /* never break UX for analytics */
  }
};

// Loads Google Analytics 4 ONLY when REACT_APP_GA_MEASUREMENT_ID is configured.
export const initAnalytics = () => {
  const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!gaId || window.__konekGaLoaded) return;
  window.__konekGaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", gaId);
};

export const EVENTS = {
  PRIMARY_CTA: "demo_cta_clicked",
  SECONDARY_CTA: "solutions_cta_clicked",
  DEVICE_VIDEO_PLAY: "device_video_played",
  FOUNDER_VIDEO_PLAY: "founder_video_played",
  PACKAGE_CTA: "package_consultation_clicked",
  FORM_STARTED: "consultation_form_started",
  FORM_SUBMITTED: "consultation_form_submitted",
  CHAT_OPENED: "ai_chat_opened",
};
